import { AnyAction } from 'redux'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { defaultFlow } from 'redux/config/saga/Common'
import automatedReportingService from 'redux/automatedReporting/automatedReportingService'
import { automatedReportingActions } from 'redux/automatedReporting/automatedReportingSlice'

export function* getScheduledReports(action: AnyAction) {
  yield put(automatedReportingActions.setScheduledReportsLoading(true))
  yield defaultFlow(
    action,
    automatedReportingService.getScheduledReports,
    automatedReportingActions.getScheduledReportsSuccess
  )
}

export function* getScheduledReportRuns(action: AnyAction) {
  yield put(automatedReportingActions.setScheduledReportRunsLoading(true))
  yield defaultFlow(
    action,
    automatedReportingService.getScheduledReportRuns,
    automatedReportingActions.getScheduledReportRunsSuccess
  )
}

export function* createScheduledReport(action: AnyAction) {
  yield put(automatedReportingActions.setScheduledReportCreateLoading(true))
  try {
    const res = yield call(
      automatedReportingService.createScheduledReport,
      action.payload
    )
    yield put(automatedReportingActions.createScheduledReportSuccess(res.data))
  } catch (error) {
    yield put(
      automatedReportingActions.createScheduledReportFailed({
        message: error instanceof Error ? error.message : String(error),
      })
    )
  }
}

export function* updateScheduledReport(action: AnyAction) {
  yield put(automatedReportingActions.setScheduledReportUpdateLoading(true))
  try {
    const res = yield call(
      automatedReportingService.updateScheduledReport,
      action.payload
    )
    yield put(automatedReportingActions.updateScheduledReportSuccess(res.data))
  } catch (error) {
    yield put(
      automatedReportingActions.updateScheduledReportFailed({
        message: error instanceof Error ? error.message : String(error),
      })
    )
  }
}

export function* watchGetScheduledReports() {
  yield takeEvery(
    automatedReportingActions.getScheduledReports.type,
    getScheduledReports
  )
}

export function* watchGetScheduledReportRuns() {
  yield takeEvery(
    automatedReportingActions.getScheduledReportRuns.type,
    getScheduledReportRuns
  )
}

export function* watchCreateScheduledReport() {
  yield takeEvery(
    automatedReportingActions.createScheduledReport.type,
    createScheduledReport
  )
}

export function* watchUpdateScheduledReport() {
  yield takeEvery(
    automatedReportingActions.updateScheduledReport.type,
    updateScheduledReport
  )
}

export default function* automatedReportingSaga() {
  yield all([
    watchGetScheduledReports(),
    watchGetScheduledReportRuns(),
    watchCreateScheduledReport(),
    watchUpdateScheduledReport(),
  ])
}
